import { queryString } from '@shared/hooks/recoil-query';
import { api_ } from '@shared/plugIn/axios';
import { LowerRole, UserRole } from '@shared/types';

import {
  bugoAgencyWorkerUpdate,
  GuestInfo,
  User,
  UserCreate,
  UserUpdate,
} from './user.interface';

export const nonAdminUpdateUser = async (userUpdate: bugoAgencyWorkerUpdate) => {
  const { data: user } = await api_.patch(`auth/me/detail`, userUpdate);
  return user;
};

export const createOrGetStoreGuest = async (guestInfo: GuestInfo, role: LowerRole) => {
  const { data: user } = await api_.post<User>(
    `${role}/user/create-or-get/store-guest`,
    guestInfo,
  );
  return user;
};

//* 게스트(임시고객) 구매자 정보 수정 — 구매 시 이름/휴대폰번호를 잘못 입력한 경우 교정
//* shopOrderId로 주문을 특정하면 그 주문에 연결된 StoreGuest 계정만 변경된다.
//* userId(user._id)는 교차 검증용 — shopOrder.user와 불일치하면 403, DB 무변경.
//* 404: 주문 없음(또는 구서버 미배포) / 400: 주문에 user 없음·형식 오류 / 403: 게스트 아님·userId 불일치 / 409: guest_id 충돌
export interface StoreGuestInfoUpdate {
  shopOrderId: string;
  userId: string; // 주문에 연결된 user 문서의 _id (교차 검증)
  name: string;
  phoneNumber: string; // 숫자만 (01012345678)
}

export const updateStoreGuestInfo = async (
  dto: StoreGuestInfoUpdate,
  role: LowerRole,
) => {
  const { data: user } = await api_.patch<User>(`${role}/user/store-guest/info`, dto);
  return user;
};

export const adminCreateUser = async (userCreate: UserCreate) => {
  const { data: user } = await api_.post<User>('admin/user', userCreate);
  return user;
};

export const adminUpdateUser = async (userUpate: UserUpdate) => {
  const { data: user } = await api_.patch<User>(`admin/user/${userUpate._id}`, userUpate);
  return user;
};

export const agencyAdminUpdateWorker = async (userUpate: UserUpdate) => {
  const { data: user } = await api_.patch<User>(
    `bugo-agency-admin/user/${userUpate._id}`,
    userUpate,
  );
  return user;
};

export const agencyAdminCreateWorker = async (userCreate: UserCreate) => {
  const { data: user } = await api_.post<User>(`bugo-agency-admin/user`, userCreate);
  return user;
};

export const adminUserListByRoles = async (roles: UserRole[]) => {
  const { data } = await api_.get<User[]>(
    `admin/user/?${queryString({
      filter: { roles: { $in: roles } },
    })}`,
  );
  return data;
};

//* GiftBrandSeller(답례품 배송관리자) 목록 - 담당 브랜드 populate
export const adminGiftBrandSellerList = async () => {
  const { data } = await api_.get<User[]>(
    `admin/user/?${queryString({
      filter: { roles: UserRole.GiftBrandSeller },
      populate: { path: 'giftItemBrands', select: 'name' },
      options: { sort: { createdAt: -1 } },
    })}`,
  );
  return data;
};

//* GiftBrandSeller 계정 생성 (담당 브랜드 지정)
export interface GiftBrandSellerCreate {
  username: string;
  password: string;
  name: string;
  phoneNumber: string;
  giftItemBrands: string[];
}

export const adminCreateGiftBrandSeller = async (dto: GiftBrandSellerCreate) => {
  const { data: user } = await api_.post<User>('admin/user', {
    username: dto.username,
    password: dto.password,
    roles: [UserRole.GiftBrandSeller],
    giftItemBrands: dto.giftItemBrands,
    info: {
      name: dto.name,
      gender: '',
      birth: '',
      phoneNumber: dto.phoneNumber,
    },
  });
  return user;
};

export const adminAgencyWorkerWelcomeSend = async (userId: string) => {
  const { data } = await api_.get(`admin/alert/agency-worker-welcome/${userId}`);
  return data;
};
